if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        this.applySameAsPictureColorProperty(formData);
        this.applyMadeToOrderVariantFallback(formData);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      applySameAsPictureColorProperty(formData) {
        const productInfo = this.closest('product-info');
        const variantSelects = document.querySelector('variant-selects');
        const selected = variantSelects?.querySelector(
          'input[data-same-as-picture]:checked, option[data-same-as-picture][selected]'
        );
        if (selected || productInfo?.sameAsPictureSelected) {
          formData.set('properties[Color]', 'Same As Picture');
        }
      }

      applyMadeToOrderVariantFallback(formData) {
        const variantsNode = document.querySelector('[data-product-variants]');
        if (!variantsNode) return;

        let variants;
        try {
          variants = JSON.parse(variantsNode.textContent);
        } catch (error) {
          return;
        }

        const selectedId = formData.get('id');
        const selectedVariant = variants.find((variant) => String(variant.id) === String(selectedId));
        if (!selectedVariant || selectedVariant.available) return;

        const productAvailable = variants.some((variant) => variant.available);
        if (!productAvailable) return;

        const optionKeys = ['option1', 'option2', 'option3'].filter((key) => selectedVariant[key]);
        const colorKey =
          ['option3', 'option2', 'option1'].find((key) => {
            const peerVariants = variants.filter((variant) =>
              optionKeys.filter((optionKey) => optionKey !== key).every((optionKey) => variant[optionKey] === selectedVariant[optionKey])
            );
            return new Set(peerVariants.map((variant) => variant[key]).filter(Boolean)).size > 1;
          }) || null;

        const fallbackVariant =
          variants.find((variant) => {
            if (!variant.available) return false;
            return optionKeys.every((key) => {
              if (key === colorKey) return true;
              return variant[key] === selectedVariant[key];
            });
          }) || variants.find((variant) => variant.available);

        if (!fallbackVariant) return;

        formData.set('id', fallbackVariant.id);

        const sameAsPictureSelected = Boolean(
          document.querySelector('variant-selects input[data-same-as-picture]:checked, variant-selects option[data-same-as-picture][selected]')
        );
        if (sameAsPictureSelected) {
          formData.set('properties[Color]', 'Same As Picture');
          return;
        }

        const selectedColor = colorKey ? selectedVariant[colorKey] : null;
        if (selectedColor) {
          formData.set('properties[Color]', selectedColor);
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
